module.exports = __webpack_public_path__ + "img/language.a3d570a6.svg";